/**
 * Components Index
 * Product Selector Quote Form
 * @author Rhys Lloyd
 */

export * from '@core/modules/ps-quote-form/components/word-selector';
export * from '@core/modules/ps-quote-form/components/quote-form';



// WEBPACK FOOTER //
// ./project/client/src/core/modules/ps-quote-form/components/index.js